import React, { useState, useEffect } from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const TicketInfo = ({
	contact,
	ticket,
	onClick,
	loading,
}) => {
	const { user } = ticket
	const [userName, setUserName] = useState('')
	const [contactName, setContactName] = useState('')

	useEffect(() => {
		if (contact) {
			setContactName(contact.name);
			if(document.body.offsetWidth < 600) {
				if (contact.name.length > 10) {
					const truncadName = contact.name.substring(0, 10) + '...';
					setContactName(truncadName);
				}
			}
		}

		if (user && contact) {
			setUserName(`${i18n.t("messagesList.header.assignedTo")} ${user.name}`);

			if(document.body.offsetWidth < 600) {
				setUserName(`${user.name}`);
			}
		}
		// Dependências vazias faziam o cabeçalho congelar no valor do primeiro
		// render: trocar o responsável ou o contato em outra sessão chegava pelo
		// socket, o ticket era atualizado, mas o nome exibido continuava o antigo.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contact, user])

	const renderAttendanceCount = () => {
		const concludedCount = ticket?.concludedCount;
		const lostCount = ticket?.lostCount;

		const hasAnyValue =
			concludedCount !== undefined ||
			lostCount !== undefined;

		// Se o backend ainda não enviou os campos e a tela está carregando, manter placeholder.
		// Se não está carregando e não há campos, não mostrar nada (compat com back antigo).
		if (!hasAnyValue && !loading) {
			return null;
		}

		const concludedValue = loading ? '...' : (concludedCount ?? 0);
		const lostValue = loading ? '...' : (lostCount ?? 0);

		return (
			<>
				<div>
					{i18n.t('tickets.attendanceCountClosedLabel')}: {concludedValue}
				</div>
				<div>
					{i18n.t('tickets.attendanceCountLostLabel')}: {lostValue}
				</div>
			</>
		);
	};

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
			title={`${contactName} #${ticket.id}`}
			subheader={
				<div>
					{ticket.user && <div>{userName}</div>}
					{renderAttendanceCount()}
				</div>
			}
		/>
	);
};

export default TicketInfo;
